/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react"
import Link from "next/link"
import PropTypes from "prop-types"
import {
 Button, Checkbox, Input, message 
} from "antd"
import { useSelector } from "react-redux"
import SmsCodeVerify from "@/components/rc-sms-verify"
import ImgVerify from "@/components/rc-img-verify"
import { orderSellCheck } from "../../service"
import { isPhone, $cookie, sessionstorage } from "$utils"
import styles from "./index.scss"

const SellFooter = (props) => {
  const city = useSelector(store => store.city)
  const [phone, setPhone] = useState(
    $cookie.get("rrc_login_phone") || sessionstorage.get("intentPhone") || ""
  ) // 手机号

  // 图形验证码
  const [imgVerify, setImgVerify] = useState()
  const [imgVerifyCode, setImgVerifyCode] = useState()

  // 短信验证码
  const [smsVerify, setSmsVerify] = useState()
  const [smsVerifyCode, setSmsVerifyCode] = useState()

  const [errMsg, setErrMsg] = useState() // 是否正获取短信验证码
  const [noteChecked, setNoteChecked] = useState(true) // 勾选协议

  // 手机号同步
  useEffect(() => {
    if (phone !== props.phone) {
      setPhone(props.phone)
    }
  }, [props.phone])

  // 提交事件
  const handleSubmit = async () => {
    if (!isPhone(phone)) {
      setErrMsg("手机号输入有误")
      return
    }
    if (!noteChecked) {
      setErrMsg("请勾选用户协议")
      return
    }
    try {
      const params = {
        mobile_number: phone,
        city: city.city,
        sell_source: "pc端",
        phone_source: city.fr,
        device: "pc",
        source: "0",
        product: "预约卖车",
        sub_product: "预约卖车",
        submit_sources: "预约卖车-PC-卖车页-2"
      }
      if (imgVerify && imgVerifyCode) {
        params.code = imgVerifyCode
      }
      if (smsVerifyCode) {
        params.vcode = smsVerifyCode
      }
      await orderSellCheck(params)
      window.location.href = `/sell/addinfo?mobile_number=${phone}`
    } catch (error) {
      console.log(error)
      if (error.status === 200) {
        const result = error.data
        const imgsrc = result?.image || result?.data?.image
        if (result.status === 100) {
          setImgVerify("")
          setErrMsg("")
        } else if (result.status === 400) {
          setImgVerify(imgsrc)
        } else if (result.status === 1000) {
          // 短信验证码
          setSmsVerify(true)
        } else if (result.status === 1001) {
          // 短信验证码错误
          setErrMsg("短信验证码输入有误")
        } else {
          message.error(result?.err_msg || result?.errMsg || "未知错误")
        }
      }
    }
  }

  return (
    <div className={styles["r-sell-footer"]}>
      <div className="content">
        <div className="boy" />
        <div className="main">
          <div className="form clearfix">
            <div className="items">
              <Input
                className="item"
                placeholder="输入您的手机号"
                data-click="SalesModule_input_phone_bottom_click"
                value={phone}
                onInput={(e) => {
                  setPhone(e.target.value)
                }}
                onChange={(e) => {
                  if (props.phone !== e.target.value) {
                    props.onPhoneChange && props.onPhoneChange(e.target.value)
                  }
                }}
                maxLength={11}
              />
              {/* 防刷图形验证码 */}
              <ImgVerify
                wrapperClassName="item"
                imgVerify={imgVerify}
                onImgVerifyCode={(code) => {
                  setImgVerifyCode(code)
                }}
                onRefresh={() => {
                  handleSubmit()
                }}
              />
              {/* 防刷短信验证码 */}
              <SmsCodeVerify
                autoSend
                wrapperClassName="item"
                phone={phone}
                smsVerify={smsVerify}
                onErrMsg={(err) => {
                  setErrMsg(err)
                }}
                onSmsCode={(code) => {
                  setSmsVerifyCode(code)
                }}
              />
            </div>

            <Button
              className="submit-btn"
              data-click="SalesModule_btn_bottom_saleofvehicles_click"
              onClick={handleSubmit}
            >
              高价卖车
            </Button>
          </div>
          {/* 错误消息 */}
          {errMsg && <p className="err-msg">{errMsg}</p>}
          <div className="note clearfix">
            <Checkbox
              className="check"
              checked={noteChecked}
              onChange={(e) => {
                setNoteChecked(e.target.checked)
              }}
            />
            <p className="txt">
              阅读并同意
              <a
                href="https://sta.renrenche.com/legal/terms.html"
                target="_blank"
              >
                《用户服务协议》
              </a>
              、
              <a
                href="https://sta.renrenche.com/legal/privacy.html"
                target="_blank"
              >
                《隐私政策》
              </a>
              提交并注册为用户。提交即视为同意人人车电联您提供服务
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SellFooter

SellFooter.propTypes = {
  phone: PropTypes.string,
  onPhoneChange: PropTypes.func // 第一次提交的intent
}

SellFooter.defaultProps = {
  phone: "",
  onPhoneChange: () => ({})
}
